import { Button, Image, Layout, Menu, Space } from 'antd';
import { useEffect, useRef, useState } from 'react';
import Icon from '@ant-design/icons';
import classes from './App.module.css';
import classNames from 'classnames';
import { ReactComponent as HamburgerIcon } from 'assets/icons/hamburger.svg';
import { NAVS } from 'app/config/routes';
import { useLocation } from 'react-router';
import QMASWhiteLogo from 'assets/images/logos/QMAS-logo-white.svg';

export default function Drawer() {
  const ref = useRef(null);
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const activeNav = location.pathname
    ?.replace(/\/(dashboard)/, '')
    ?.split('/')[1];
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    // Function to check if click is outside the drawer
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target) && !collapsed) {
        toggleCollapsed(); // Close the drawer
      }
    };

    // Add click event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Remove event listener on cleanup
      document.removeEventListener('mousedown', handleClickOutside);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed]);

  return (
    <Layout.Sider
      ref={ref}
      className={classes.drawer}
      collapsible
      width={260}
      collapsedWidth={64}
      collapsed={collapsed}
      trigger={null}
    >
      <Space
        className={classNames(classes.header, {
          [classes.headerCollapsed]: collapsed
        })}
      >
        <Button
          size="large"
          className={classNames(classes.hamburgerMenu)}
          type="text"
          onClick={toggleCollapsed}
          icon={<Icon component={HamburgerIcon}></Icon>}
        ></Button>
        {!collapsed && (
          <Space>
            <Image
              preview={false}
              width={60}
              height={24}
              src={QMASWhiteLogo}
            ></Image>
            {/* <Dropdown
              menu={{
                items: [{ key: 'standard', label: <span>Standard</span> }]
              }}
            ></Dropdown> */}
          </Space>
        )}
      </Space>
      <Menu
        className={classes.navs}
        theme="dark"
        mode="inline"
        defaultActiveFirst
        selectedKeys={[activeNav]}
        items={NAVS}
      ></Menu>
    </Layout.Sider>
  );
}
